import { isEqual } from 'lodash/fp';
import { DefaultErrorBoundary, LocalizedParagraph } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { getAmountDueForBillIds, getOrderedBillsByOwnerIdAndAssociatedIdCount } from '../selectors';
import { BillListHeader, NewBillButton } from '../components';
import { BillCardList } from '../BillCardList';
import { AccountBillingButton } from './AccountBillingButton';

interface CustomerCardProps {
    accountId: string;
    fullName: string;
    billIds: string[];
}

export const CustomerCard: React.FC<CustomerCardProps> = ({ accountId, billIds, fullName }) => {
    const { totalAmount, billAmounts } = useCommanderSelector(
        (state) => getAmountDueForBillIds(state, { enterpriseId: getCurrentEnterpriseId(), billIds }),
        isEqual
    );

    const billCount = useCommanderSelector((state) =>
        getOrderedBillsByOwnerIdAndAssociatedIdCount(state, { ownerId: accountId, associatedAccountId: accountId })
    );

    return (
        <DefaultErrorBoundary>
            <Stack vertical spacing="200">
                <BillListHeader
                    title={fullName}
                    buttons={[
                        <NewBillButton key="NewBillButton" accountId={accountId} />,
                        <AccountBillingButton key="AccountBillingButton" accountId={accountId} billCount={billCount} />,
                    ]}
                    amount={totalAmount}
                />
                {billIds.length === 0 ? <LocalizedParagraph textKey={TextKey.NoOpenBillsOnGuest} /> : null}
                <BillCardList billIds={billIds} billAmounts={billAmounts} accountId={accountId} containerHeight={800} />
            </Stack>
        </DefaultErrorBoundary>
    );
};
